import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { formatPrice } from '@/lib/utils'
import Link from 'next/link'

const CartSummary = ({ cartTotal }: { cartTotal: number }) => {
  return (
    <Card>
      <CardContent>
        <h2 className='text-lg font-medium text-gray-900'>Order Summary</h2>
        <div className='mt-6 space-y-4'>
          <div className='flex items-center justify-between'>
            <p className='text-sm text-gray-600'>Subtotal</p>
            <p className='text-sm font-medium text-gray-900'>{formatPrice(cartTotal)}</p>
          </div>
          <div className='flex items-center justify-between'>
            <p className='text-sm text-gray-600'>Delivery Charges</p>
            <p className='text-sm font-medium text-gray-900'>{formatPrice(0)}</p>
          </div>
          <div className='flex items-center justify-between border-t border-gray-200 pt-4' ><div className='text-bae font-medium text-gray-900'>
            <span>Order Total</span></div>
            <div className='text-base font-medium text-gray-900'>
              <span>{formatPrice(cartTotal)}</span>
            </div>
          </div>
        </div>
        {cartTotal > 0 &&
          <div className='mt-6'>
            <Button size={"lg"} className='w-full' asChild><Link href={"/checkout"}>Checkout</Link></Button>
          </div>
        }
      </CardContent>
    </Card>
  )
}

export default CartSummary